export default __webpack_public_path__ + "static/media/home.5bb00477.svg";